export const parseInlineMarkdown = (value) => {
  const text = String(value || "");
  const parts = [];
  const pattern = /(`[^`]+`|\*\*[\s\S]+?\*\*)/g;
  let lastIndex = 0;

  for (const match of text.matchAll(pattern)) {
    if (match.index > lastIndex) {
      parts.push({ type: "text", text: text.slice(lastIndex, match.index) });
    }

    const token = match[0];
    if (token.startsWith("`")) {
      parts.push({ type: "inlineCode", text: token.slice(1, -1) });
    } else {
      parts.push({ type: "bold", text: token.slice(2, -2) });
    }
    lastIndex = match.index + token.length;
  }

  if (lastIndex < text.length) {
    parts.push({ type: "text", text: text.slice(lastIndex) });
  }

  return parts.length ? parts : [{ type: "text", text }];
};

const flushParagraph = (blocks, lines) => {
  if (!lines.length) return [];
  blocks.push({ type: "paragraph", text: lines.join("\n").trim() });
  return [];
};

export const parseMarkdownBlocks = (value) => {
  const lines = String(value || "").replace(/\r\n/g, "\n").split("\n");
  const blocks = [];
  let paragraphLines = [];
  let listItems = [];

  const flushList = () => {
    if (!listItems.length) return;
    blocks.push({ type: "orderedList", items: listItems });
    listItems = [];
  };

  lines.forEach((line) => {
    const headingMatch = line.match(/^(#{1,6})\s+(.+)$/);
    if (headingMatch) {
      paragraphLines = flushParagraph(blocks, paragraphLines);
      flushList();
      blocks.push({
        type: "heading",
        level: headingMatch[1].length,
        text: headingMatch[2].trim(),
      });
      return;
    }

    const orderedMatch = line.match(/^\s*(\d+)[.)]\s+(.+)$/);
    if (orderedMatch) {
      paragraphLines = flushParagraph(blocks, paragraphLines);
      listItems.push({ number: orderedMatch[1], text: orderedMatch[2].trim() });
      return;
    }

    if (!line.trim()) {
      paragraphLines = flushParagraph(blocks, paragraphLines);
      flushList();
      return;
    }

    flushList();
    paragraphLines.push(line);
  });

  flushParagraph(blocks, paragraphLines);
  flushList();

  return blocks;
};
